import { cn, getVersionForClone } from '@qr-front/ui/utils'

export const socialButtonStyle = cn(
	'flex h-12 w-full items-center justify-center gap-2 border border-border-grey text-button-small text-dark-grey hover:shadow-generator',
	getVersionForClone({
		base: 'rounded-8',
		clone1: 'rounded-full',
	}),
)
